import * as angular from 'angular';
import { IComponentOptions } from 'angular';

export default angular.module('app.viewComponents', [])

;
